const getAutomaticScrapingSettings = modelId => ({
  mode: 'Automatic',
  proxy: 'DataCenter',
  fingerprints: 'Enabled',
  cookieBlocker: 'Enabled',
  modelId,
})

export default getAutomaticScrapingSettings
